module.exports = __webpack_public_path__ + "static/img/5.87119212.png";